import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultComponent } from './default.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { NgxSpinnerModule } from "ngx-spinner";
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TextMaskModule } from 'angular2-text-mask';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { getDutchPaginatorIntl } from '../../interfaces/traducao.paginator';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

//Components
import { DashboardComponent } from '../../modules/dashboard/dashboard.component';
import { NovoFornecedorComponent } from '../../modules/novo-fornecedor/novo-fornecedor.component';
import { RefreshComponent } from '../../modules/refresh/refresh.component';
import { ConsultarFornecedorComponent } from '../../modules/consultar-fornecedor/consultar-fornecedor.component';
import { NovoProdutoComponent } from '../../modules/novo-produto/novo-produto.component';
import { NovoGrupoComponent } from '../../modules/novo-grupo/novo-grupo.component';
import { ConsultarGrupoComponent } from '../../modules/consultar-grupo/consultar-grupo.component';
import { ConsultarProdutoComponent } from '../../modules/consultar-produto/consultar-produto.component';
import { NovoUnidadeMedidaComponent } from '../../modules/novo-unidade-medida/novo-unidade-medida.component';
import { ConsultarUnidadeMedidaComponent } from '../../modules/consultar-unidade-medida/consulta-unidade-medida.component';
import { ConsultarClienteComponent } from '../../modules/consultar-cliente/consultar-cliente.component';
import { NovoClienteComponent } from '../../modules/novo-cliente/novo-cliente.component';
import { NovoFuncionarioComponent } from '../../modules/novo-funcionario/novo-funcionario.component';
import { ConsultarFuncionarioComponent } from '../../modules/consultar-funcionario/consultar-funcionario.component';
import { SolicitacoesCadastroComponent } from '../../modules/solicitacoes-cadastro/solicitacoes-cadastro.component';
import { ConsultarPedidoComponent } from '../../modules/consultar-pedidos/consultar-pedidos.component';
import { ValoresMinimosComponent } from '../../modules/valores-minimos/valores-minimos.component';
import { RelatorioVendasComponent } from '../../modules/relatorio-vendas/relatorio-vendas.component';
import { RelatorioComissaoComponent } from '../../modules/relatorio-comissao/relatorio-comissao.component';
import { NovaCidadeComponent } from '../../modules/nova-cidade/nova-cidade.component';
import { RelatorioMercadoriasVendidasComponent } from '../../modules/relatorio-mercadorias-vendidas/relatorio-mercadorias-vendidas.component';
import { GerenciarPromocoesComponent } from '../../modules/gerenciar-promocoes/gerenciar-promocoes.component';
import { FecharComissaoComponent } from '../../modules/fechar-comissao/fechar-comissao.component';
import { RelatorioEstoqueComponent } from '../../modules/relatorio-estoque/relatorio-estoque.component';
import { RelatorioPagamentosComponent } from '../../modules/relatorio-pagamentos/relatorio-pagamentos.component';
// import { ValidarEstoqueComponent } from '../../modules/validar-estoque/validar-estoque.component';
import { RelatorioAcessosComponent } from '../../modules/relatorio-acessos/relatorio-acessos.component';
import { MapaRotasComponent } from '../../modules/mapa-rotas/mapa-rotas.component';
import { ControleEstoqueComponent } from '../../modules/controle-estoque/controle-estoque.component';
import { ErroCadastroLatLngComponent } from '../../modules/erro-cadastro-lat-lng/erro-cadastro-lat-lng.component';
import { RelatorioPromocoesClientesComponent } from '../../modules/relatorio-promocoes-clientes/relatorio-promocoes-clientes.component';
import { RelatorioBoletosComponent } from '../../modules/relatorio-boletos/relatorio-boletos.component';
import { RelatorioMovimentacaoEstoqueComponent } from '../../modules/relatorio-movimentacao-estoque/relatorio-movimentacao-estoque.component';
import { VincularPromocaoLoteClientesComponent } from '../../modules/vincular-promocao-lote-clientes/vincular-promocao-lote-clientes.component';
import { SolicitacoesExclusaoDadosComponent } from '../../modules/solicitacoes-exclusao-dados/solicitacoes-exclusao-dados.component';
import { AdicionarCreditoComponent } from '../../modules/adicionar-credito/adicionar-credito.component';
import { GerarBoletoComponent } from '../../modules/gerar-boleto/gerar-boleto.component';


//Dialogs
import { NovoGrupoDialog } from '../../modules/dialogs/novo-grupo-dialog/novo-grupo-dialog';
import { NovoUnidadeMedidaDialog } from '../../modules/dialogs/novo-unidade-medida-dialog/novo-unidade-medida-dialog';
import { NovoFornecedorDialog } from '../../modules/dialogs/novo-fornecedor-dialog/novo-fornecedor-dialog';
import { UploadImagemDialogDialog } from '../../modules/dialogs/upload-imagem-dialog/upload-imagem-dialog';
import { CancelarPedidoDialog } from '../../modules/dialogs/cancelar-pedido-dialog/cancelar-pedido-dialog';
import { AlterarFormaPagamentoDialog } from '../../modules/dialogs/alterar-forma-pagamento-dialog/alterar-forma-pagamento-dialog';
import { AlertaExportarDialog } from '../../modules/dialogs/exportar-dialog/exportar-dialog';
import { AlertaTipoImpressaoDialog } from '../../modules/dialogs/tipo-impressao-dialog/tipo-impressao-dialog';
import { ProdutosDescontoPersonalizadoDialog } from '../../modules/dialogs/produtos-desconto-personalizado-dialog/produtos-desconto-personalizado-dialog';
import { RemoverProdutoDialog } from '../../modules/dialogs/remover-produtos-dialog/remover-produtos-dialog';
import { MapaLatlngClienteDialog } from '../../modules/dialogs/mapa-latlng-cliente-dialog/mapa-latlng-cliente-dialog.component';
import { RetornarStatusPedidoDialog } from '../../modules/dialogs/retornar-status-pedido-dialog/retornar-status-pedido-dialog.component';
import { ExcluirClienteDialog } from '../../modules/dialogs/excluir-cliente-dialog/excluir-cliente-dialog.component';
import { AlterarStatusPedidoDemandaDialog } from '../../modules/dialogs/alterar-status-pedido-demanda-dialog/alterar-status-pedido-demanda-dialog';
import { AlterarPromocaoDemandaDialog } from '../../modules/dialogs/alterar-promocao-demanda-dialog/alterar-promocao-demanda-dialog';
import { GerarBoletoDialog } from '../../modules/dialogs/gerar-boleto-dialog/gerar-boleto-dialog';
import { GerarBoletoDemandaDialog } from '../../modules/dialogs/gerar-boleto-demanda-dialog/gerar-boleto-demanda-dialog';
import { CancelarBoletoDialog } from '../../modules/dialogs/cancelar-boleto-dialog/cancelar-boleto-dialog';
import { GerarCanhotosDialog } from '../../modules/dialogs/gerar-canhotos-dialog/gerar-canhotos-dialog';
import { AdicionarCreditoVoucherDialog } from '../../modules/dialogs/adicionar-credito-voucher-dialog/adicionar-credito-voucher-dialog';

import { SidenavService } from '../../services/sidenav.service';
import { NgxImageCompressService } from 'ngx-image-compress';


// import { BrowserModule } from '@angular/platform-browser';
import { AgmCoreModule } from '@agm/core';
import { AlterarPagamentosDemandaDialog } from '../../modules/dialogs/confirmar-pagamento-dialog/confirmar-pagamento-dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ManutencaoLojaComponent } from '../../modules/manutencao-loja/manutencao-loja.component';
import { GerenciarEstoqueComponent } from '../../modules/gerenciar-estoque/gerenciar-estoque.component';
import { AlertaAlterarCreditoClienteDialog } from '../../modules/dialogs/alterar-credito-clientes-dialog/alterar-credito-clientes-dialog';


@NgModule({
  declarations: [
    DefaultComponent,
    DashboardComponent,
    NovoFornecedorComponent,
    RefreshComponent,
    ConsultarFornecedorComponent,
    NovoProdutoComponent,
    NovoGrupoComponent,
    ConsultarGrupoComponent,
    ConsultarProdutoComponent,
    NovoUnidadeMedidaComponent,
    ConsultarUnidadeMedidaComponent,
    ConsultarClienteComponent,
    NovoClienteComponent,
    NovoFuncionarioComponent,
    ConsultarFuncionarioComponent,
    SolicitacoesCadastroComponent,
    ConsultarPedidoComponent,
    ValoresMinimosComponent,
    RelatorioVendasComponent,
    RelatorioComissaoComponent,
    NovaCidadeComponent,
    RelatorioMercadoriasVendidasComponent,
    GerenciarPromocoesComponent,
    FecharComissaoComponent,
    RelatorioEstoqueComponent,
    RelatorioPagamentosComponent,
    RelatorioAcessosComponent,
    // ValidarEstoqueComponent,
    MapaRotasComponent,
    ControleEstoqueComponent,
    ErroCadastroLatLngComponent,
    RelatorioPromocoesClientesComponent,
    RelatorioBoletosComponent,
    RelatorioMovimentacaoEstoqueComponent,
    VincularPromocaoLoteClientesComponent,
    SolicitacoesExclusaoDadosComponent,
    RelatorioBoletosComponent,
    AdicionarCreditoComponent,
    GerarBoletoComponent,
    ManutencaoLojaComponent,
    GerenciarEstoqueComponent,

    //Dialogs
    NovoGrupoDialog,
    NovoUnidadeMedidaDialog,
    NovoFornecedorDialog,
    UploadImagemDialogDialog,
    CancelarPedidoDialog,
    AlterarFormaPagamentoDialog,
    AlertaAlterarCreditoClienteDialog,
    AlertaExportarDialog,
    AlertaTipoImpressaoDialog,
    ProdutosDescontoPersonalizadoDialog,
    RemoverProdutoDialog,
    MapaLatlngClienteDialog,
    RetornarStatusPedidoDialog,
    ExcluirClienteDialog,
    AlterarStatusPedidoDemandaDialog,
    AlterarPagamentosDemandaDialog,
    AlterarPromocaoDemandaDialog,
    GerarBoletoDialog,
    GerarBoletoDemandaDialog,
    CancelarBoletoDialog,
    GerarCanhotosDialog,
    AdicionarCreditoVoucherDialog
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    MatSidenavModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    FlexLayoutModule,
    MatGridListModule,
    MatIconModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    TextMaskModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    MatTableModule,
    MatPaginatorModule,
    MatTabsModule,
    MatSelectModule,
    CurrencyMaskModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatStepperModule,
    MatDialogModule,
    BrowserModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBLhdcuvEPFwKz0gQHWvAFcl-rkL_JTSrE'
    }),
    MatRadioModule,
    ImageCropperModule,
    MatSliderModule,
    MatTooltipModule,
    MatChipsModule,
    HttpClientModule,
    MatProgressBarModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule
  ],
  providers: [
    //Formato das datas
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    //Tradução do paginator
    { provide: MatPaginatorIntl, useValue: getDutchPaginatorIntl() },
    SidenavService,
    NgxImageCompressService
  ],
})
export class DefaultModule { }
